import { ESColorClassification } from '../../../ProductTypes';
import { HeaderTagView, ProductDetailsHeaderTag } from './productDetailsHeaderTags.types';

const isColorClassification = (tag: ProductDetailsHeaderTag): tag is ESColorClassification =>
  'classificationType' in tag;

export const toHeaderTagViews = (tags: ProductDetailsHeaderTag[]): HeaderTagView[] =>
  tags.reduce<HeaderTagView[]>((acc, tag) => {
    if (!isColorClassification(tag)) {
      acc.push({
        id: tag.id,
        label: tag.name,
        fontColor: tag.fontColor,
        backgroundColor: tag.backgroundColor,
      });
      return acc;
    }

    if (!tag.classificationType.useAsTag) {
      return acc;
    }

    acc.push({ id: tag.id, label: tag.name, description: tag.description });
    return acc;
  }, []);
